module.exports = __webpack_public_path__ + "img/SmallPlay.0d73b3ca.svg";